<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>ORDER_NOT_GENERATE</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="nmInterface && datatable"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              multiselect
              selectionForce
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
              :column-edit="columnEdit"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              @click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'

const { pageTable } = JtCrud

@Component({
  name: 'BillingOrderPageSearch',
  mixins: [
    pageTable
  ]
})
class BillingOrderPageSearch extends Vue {
    nmInterface = 'billingOrder.pesquisar'
    datatable = null
    async mounted () {
      this.datatable = await repository.resolveDatatable(this.nmInterface)
    }

    actionButton (button, params) {
      this.$emit('action-button', button, this.$refs.jtDataTable.$refs.table.selected)
    }
}
export default BillingOrderPageSearch
</script>
